import dynamic from 'next/dynamic';
import { RateListProps } from '../RateList/RateList.types';

export const RateListMenu = dynamic<RateListProps>(() => import('./RateListMenu'));
